/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { trendTabularActions } from 'modules/dashboard/components/tab-container/trend-tabular-tabs/slice';
import { API } from 'modules/dashboard/constants';
/**
 * Get trend data generator function to get organization related data
 * @param {*} param0
 */
export function* getTrendDataGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_JS_VISUAL_DATA, payload);
    yield put(trendTabularActions.getTrendDataSucceeded(response));
  } catch (error) {
    yield put(trendTabularActions.getTrendDataFailed(error?.message));
  }
}
//
export function* trendTabularSaga() {
  yield takeLatest(trendTabularActions.getTrendData.type, getTrendDataGenerator);
}
//
export default trendTabularSaga;
